import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class PropietarioService extends BaseService {
  url = `${this.apiUrl}propietario`;

  constructor(private http: HttpClient) {
    super();
  }

  getPropietario(propietarioId: number): Observable<any> {
    const propietario = propietarioId.toString();
    return this.http.get<any>(`${this.url}/${propietario}`);
  }

  getList(): Observable<any[]> {
    return this.http.get<any[]>(`${this.url}`);
  }

  getPaginate(skip: number = 0, limit: number = 0, sortBy: string, direction: string): Observable<any[]> {
    let toGet = `${this.url}/paginate/?skip=${skip}&limit=${limit}`;
    toGet = sortBy && direction ? toGet.concat(`&sort_by=${sortBy}&direction=${direction}`) : toGet;
    return this.http.get<any[]>(toGet);
  }

  savePropietario(formData): Observable<any> {
    return this.http.post<any>(`${this.url}/`, formData);
  }

  updatePropietario(propietarioId: number, formData): Observable<any> {
    return this.http.put<any>(`${this.url}/${propietarioId}`, formData);
  }

  activeInactivePropietario(propietarioId: number): Observable<any> {
    return this.http.patch<any>(`${this.url}/${propietarioId}`, {});
  }

}
